import { NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import * as i1 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
const _c0 = ["ng-doc-label", ""];
const _c1 = ["*"];
function NgDocLabelComponent_span_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r1 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(text_r1);
  }
}
function NgDocLabelComponent_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtemplate(1, NgDocLabelComponent_span_0_ng_container_1_Template, 2, 1, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r1.label);
  }
}
let NgDocLabelComponent = /*#__PURE__*/(() => {
  class NgDocLabelComponent {
    constructor() {
      this.label = '';
      this.align = 'left';
    }
    static {
      this.ɵfac = function NgDocLabelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocLabelComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocLabelComponent,
        selectors: [["label", "ng-doc-label", ""]],
        hostVars: 1,
        hostBindings: function NgDocLabelComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-align", ctx.align);
          }
        },
        inputs: {
          label: [0, "ng-doc-label", "label"],
          align: "align"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        attrs: _c0,
        ngContentSelectors: _c1,
        decls: 3,
        vars: 1,
        consts: [["class", "ng-doc-label", 4, "ngIf"], [1, "ng-doc-content"], [1, "ng-doc-label"], [4, "polymorpheusOutlet"]],
        template: function NgDocLabelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NgDocLabelComponent_span_0_Template, 2, 1, "span", 0);
            i0.ɵɵelementStart(1, "span", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.label);
          }
        },
        dependencies: [NgIf, PolymorpheusModule, i1.PolymorpheusOutletDirective],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:flex-start;pointer-events:none}[data-ng-doc-align=right][_nghost-%COMP%]   .ng-doc-label[_ngcontent-%COMP%]{align-self:flex-end;text-align:end}.ng-doc-label[_ngcontent-%COMP%]{font-family:var(--ng-doc-font-family);font-variant:no-contextual;color:var(--ng-doc-text);line-height:var(--ng-doc-line-height);font-size:var(--ng-doc-font-size);font-weight:var(--ng-doc-font-weight);display:flex;flex-direction:row;pointer-events:auto;margin-bottom:calc(var(--ng-doc-base-gutter) / 2)}.ng-doc-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start;width:var(--ng-doc-label-content-width, 100%)}.ng-doc-content[_ngcontent-%COMP%] > *[_ngcontent-%COMP%], .ng-doc-content[_ngcontent-%COMP%]    >*{pointer-events:auto}"],
        changeDetection: 0
      });
    }
  }
  return NgDocLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocLabelComponent };
